/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import styles from './Footer.scss'

export const AFFIRMATIVE = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.affirmative'
        defaultMessage='Так точно!'
    />
)

export const TANK_IS_ALREADY_IN_HANGAR = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.tank_is_already_in_hangar'
        defaultMessage='Эта машина уже есть в вашем Ангаре.'
    />
)

export const TANK_IS_ALREADY_SELECTED = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.tank_is_already_selected'
        defaultMessage='Вы уже выбрали другую награду в данной категории.'
    />
)

export const TANK_IS_ALREADY_PURCHASED = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.tank_is_already_purchased'
        defaultMessage='Награда получена и будет начислена на ваш аккаунт в ближайшее время.'
    />
)

export const WG_MONEY_UNAVAILABILE = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.wg_money_unavailable'
        defaultMessage='Получение наград временно недоступно. Попробуйте позже.'
    />
)

export const ENOUGH_PFP = (topBestCount) => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.enough_pfp'
        defaultMessage='Поздравляем! Вы вошли в {topBestCount} игроков по итогам события и получили право на получение награды.'
        values={{ topBestCount }}
    />
)

export const NOT_ENOUGH_PFP = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.not_enough_pfp'
        defaultMessage='К сожалению, вы набрали недостаточное количество Очков славы в течение события, но вы можете использовать боны для участия в аукционе за получение наград.'
    />
)

export const EVENT_NOT_FINISHED_NO_AUCTION_TICKET = (topBestCount) => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.event_not_finished_no_auction_ticket'
        defaultMessage='Технику за фиксированное количество бон смогут получить игроки, вошедшие в {topBestCount} по итогам события. Остальным игрокам необходимо собрать в Мастерской допуск на аукцион техники для возможности получить призовые машины, делая ставки в боновом аукционе. Необходимое количество личных Очков славы для получения техники станет известно после завершения события.'
        values={{ topBestCount }}
    />
)

export const EVENT_NOT_FINISHED_HAS_AUCTION_TICKET = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.event_not_finished_has_auction_ticket'
        defaultMessage='Получение наград станет доступно после окончания события.'
    />
)

export const TOP_BEST_COUNT = (number) => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.top_best_count'
        defaultMessage='топ-{top}'
        values={{ top: <FormattedNumber value={number} /> }}
    />
)

export const TO_CHANGE = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.to_change'
        defaultMessage='к обмену:'
    />
)

export const WARNING_MESSAGE_NOT_ENOUGH_BONS = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.warning_message_no_enough_bons'
        defaultMessage='У вас недостаточно бон для участия в аукционе.'
    />
)

export const WARNING_MESSAGE_NOT_ENOUGH_BONS_FOR_PURCHASE = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.warning_message_no_enough_bons_to_purchase'
        defaultMessage='У вас недостаточно бон для получения награды.'
    />
)

export const MINIMAL_RATE = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.minimal_rate'
        defaultMessage='Минимальная ставка:'
    />
)

export const BET_ACCEPTED = (datetimeEnd) => (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.bet_accepted'
        defaultMessage='Принята ставка в аукционе на получение приза. Определение победителей состоится {datetimeEnd}.'
        values={{
            datetimeEnd: (<span className={styles.finishedDate}>{datetimeEnd.format('L, LT')}</span>),
        }}
    />
)

export const BET_LOST = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.lost_bet'
        defaultMessage='При проигрыше боны будут возвращены на ваш счёт.'
    />
)

export const YOUR_BET = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.foter.your_bet'
        defaultMessage='Ваша ставка:'
    />
)

export const MAKE_BET = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.make_bet'
        defaultMessage='К сожалению, вы набрали недостаточное количество Очков славы в течение события, но вы можете использовать боны для участия в аукционе за получение наград.'
    />
)

export const MAKE_BET_TEXT = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.make_bet_text'
        defaultMessage='Сделать ставку'
    />
)

export const CANCEL_BET = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.cancel_bet'
        defaultMessage='Отменить ставку'
    />
)

export const PURCHASE_REWARD = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.purchase_reward'
        defaultMessage='Получить награду'
    />
)

export const EVENT_FINISHED_NO_AUCTION_TICKET = (
    <FormattedMessage
        id='wgcwx_shop.rewards.tank.footer.event_finished_has_no_auction_ticket'
        defaultMessage='Вы не собрали в Мастерской допуск на аукцион техники для получения наградных машин за боны.'
    />
)


// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/translations.jsx